import { app } from '../../../app';

app.factory('DataDeletionFormService', DataDeletionFormService);

/** @ngInject */
function DataDeletionFormService($resource) {
    return $resource('https://www.setlockone.com/sd/app/rest/datadeletion', {});
}



// WEBPACK FOOTER //
// ./src/portal/states/public/data-deletion-form/data-deletion-form.service.js